<template>
  <v-card
    class="pa-0 rounded-0 elevation-0"
    :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
  >
    <v-sheet
      class="transactionTable marketingTable"
      :class="$vuetify.theme.dark ? 'blue-darken-5 ' : 'white-lighten-1'"
    >
      <v-card-text class="d-flex justify-space-between px-3 pb-5">
        <v-card-title class="pa-0">Uploaded Banners</v-card-title>
        <v-dialog
          transition="scale-transition"
          origin="center center"
          max-width="324"
          v-model="dialog"
          content-class="deposit-withdraw-popup marketingPopup"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              tile
              small
              v-bind="attrs"
              v-on="on"
              elevation="0"
              class="text-capitalize btn-account"
              color="teal-lighten-1"
              >+ New Banner</v-btn
            >
          </template>

          <v-card
            class="rounded-0 pa-7"
            :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
          >
            <v-card-title class="pb-3 text-left justify-start pl-3">
              Upload Banner
            </v-card-title>
            <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
              You Can Upload New Banner From Here
            </v-card-subtitle>
            <v-card
              class="deposit-form px-3 py-4"
              :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
            >
              <v-row>
                <v-col cols="12">
                  <fieldset>
                    <legend>Category</legend>
                    <v-select
                      v-model="selectedCategoryId"
                      solo
                      :items="categoryOptions"
                      item-value="id"
                      item-text="text"
                      append-icon="mdi-chevron-down"
                      label="Click to Select"
                      class="custom-select"
                      hide-details
                    ></v-select>
                  </fieldset>
                </v-col>
                <v-col cols="12">
                  <fieldset>
                    <legend>Resolution</legend>
                    <v-select
                      v-model="selectedResolution"
                      solo
                      :items="resolutionOptions"
                      item-value="id"
                      item-text="text"
                      append-icon="mdi-chevron-down"
                      label="Click to Select"
                      class="custom-select"
                      hide-details
                    ></v-select>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <div class="input-file">
                    <span>Upload Banner</span>
                    <v-file-input
                      ref="fileInput"
                      label="Choose file"
                      filled
                      prepend-icon="mdi-file-image"
                      hide-details
                      @change="handleFileUpload"
                    ></v-file-input>
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions>
              <v-row dense>
                <v-col cols="6">
                  <v-btn
                    tile
                    block
                    @click="newBanner"
                    elevation="0"
                    :loading="isLoading"
                    :disabled="isLoading"
                    class="text-capitalize btn-account"
                    color="teal-lighten-1"
                    >Upload</v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-btn
                    tile
                    block
                    outlined
                    @click="dialog = false"
                    elevation="0"
                    class="text-capitalize btn-account"
                    >Close</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-data-table
        :items-per-page="10"
        :headers="headers"
        :items="filteredBanners"
      >
        <template v-slot:item.action="{ item }">
          <div class="trade-dropdown">
            <v-menu
              rounded="0"
              class="trade-dropdown-menu"
              transition="slide-x-transition"
              bottom
              left
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  small
                  tile
                  elevation="0"
                  class="ma-0 text-capitalize btn-account"
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="dropdown-menu-card" tile flat>
                <v-list
                  flat
                  elevation="0"
                  :class="
                    $vuetify.theme.dark ? '$blue-darken-1' : 'white-lighten-1'
                  "
                >
                  <v-list-item-group>
                    <v-list-item :ripple="false">
                      <v-list-item-content>
                        <!-- EDIT -->
                        <v-dialog
                          transition="scale-transition"
                          origin="center center"
                          max-width="324"
                          v-model="editDialog"
                          content-class="deposit-withdraw-popup marketingPopup"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              tile
                              small
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              class="text-capitalize btn-account"
                              color="teal-lighten-1"
                              >Edit</v-btn
                            >
                          </template>

                          <v-card
                            class="rounded-0 pa-7"
                            :class="
                              $vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                            "
                          >
                            <v-card-title
                              class="pb-3 text-left justify-start pl-3"
                            >
                              Edit Banner
                            </v-card-title>
                            <v-card-subtitle
                              class="mt-0 pl-3 pb-0 pr-10 text--ash"
                            >
                              You Can Edit This Banner From Here
                            </v-card-subtitle>
                            <v-card
                              class="deposit-form px-3 py-4"
                              :class="
                                $vuetify.theme.dark
                                  ? 'blue-darken-1'
                                  : 'white-lighten-5'
                              "
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-img
                                    :src="item.banner_file"
                                    :width="item.banner_file"
                                    alt="banner image"
                                    style="width: 100%; height: 100px"
                                  />
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <div class="input-file">
                                    <span>Upload New Banner</span>
                                    <v-file-input
                                      label="Choose file"
                                      filled
                                      prepend-icon="mdi-file-image"
                                      hide-details
                                      @change="
                                        uploadFileUpload($event, item?.id)
                                      "
                                    ></v-file-input>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card>
                            <v-card-actions>
                              <v-row dense>
                                <!-- <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    @click="updateFile(item?.id)"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    color="teal-lighten-1"
                                    >Upload</v-btn
                                  >
                                </v-col> -->
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    outlined
                                    @click="editDialog = false"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    >Close</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <!-- DELETE -->
                        <v-dialog
                          transition="scale-transition"
                          origin="center center"
                          max-width="324"
                          v-model="deleteDialog"
                          content-class="deposit-withdraw-popup marketingPopup"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              tile
                              small
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              class="text-capitalize btn-account"
                              color="teal-lighten-1"
                              >Delete</v-btn
                            >
                          </template>

                          <v-card
                            class="rounded-0 pa-7"
                            :class="
                              $vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                            "
                          >
                            <v-card-title
                              class="pb-3 text-left justify-start pl-3"
                            >
                              Delete Banner
                            </v-card-title>
                            <v-card-subtitle
                              class="mt-0 pl-3 pb-0 pr-10 text--ash"
                            >
                              Do you want to delete?
                            </v-card-subtitle>
                            <v-card
                              class="deposit-form px-3 py-4"
                              :class="
                                $vuetify.theme.dark
                                  ? 'blue-darken-1'
                                  : 'white-lighten-5'
                              "
                            >
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-img
                                    :src="item.banner_file"
                                    :width="item.banner_file"
                                    alt="banner image"
                                    style="width: 100%; height: 100px"
                                  />
                                </v-col>
                              </v-row>
                            </v-card>
                            <v-card-actions>
                              <v-row dense>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    @click="deletebanner(item?.id)"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    color="teal-lighten-1"
                                    >Delete</v-btn
                                  >
                                </v-col>
                                <v-col cols="6">
                                  <v-btn
                                    tile
                                    block
                                    outlined
                                    @click="deleteDialog = false"
                                    elevation="0"
                                    class="text-capitalize btn-account"
                                    >Cancel</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.sl="{ item, index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.banner_file="{ item }">
          <img
            :src="item.banner_file"
            :width="item.banner_file"
            alt="banner image"
          />
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { MARKETTINGTOOLS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      panel: [0],
      dialog: false,
      editDialog: false,
      deleteDialog: false,
      isLoading: false,
      selectedCategoryId: null,
      selectedResolution: null,
      selectedFile: null,
      updatedFile: null,
      headers: [
        { text: "SL", align: "start", value: "sl" },
        { text: "Banner Category", value: "category_name" },
        { text: "Banner Resolution", value: "banner_size" },
        { text: "File", value: "banner_file" },
        { text: "Action", value: "action" },
      ],
      updatedBanners: [],
      bannerType: null,
    };
  },

  computed: {
    ...mapState("markettingtools", [
      "banners",
      "bannerSizes",
      "bannerCategories",
    ]),
    categoryOptions() {
      return this.bannerCategories.map((category) => ({
        id: category.id,
        text: category.category_name,
      }));
    },
    resolutionOptions() {
      return this.bannerSizes.map((category) => ({
        id: category.id,
        text: category.width + "*" + category.height,
      }));
    },

    filteredBanners() {
      if (this.bannerType) {
        return this.banners.filter(
          (banner) =>
            banner.category_name.toLowerCase() === this.bannerType.toLowerCase()
        );
      } else {
        return this.banners;
      }
    },
  },
  methods: {
    ...mapActions("markettingtools", [
      MARKETTINGTOOLS__ACTIONS.BANNERS,
      MARKETTINGTOOLS__ACTIONS.CREATEBANNER,
      MARKETTINGTOOLS__ACTIONS.DELETEBANNER,
      MARKETTINGTOOLS__ACTIONS.UPDATEBANNER,
    ]),

    async handleFileUpload(file) {
      const formData = new FormData();
      formData.append("selectedCategoryId", this.selectedCategoryId);
      formData.append("selectedResolution", this.selectedResolution);
      formData.append("banner_file", file);
      this.selectedFile = formData;
    },

    async newBanner() {
      try {
        if (!this.selectedCategoryId) {
          toast.error("Please select a category!");
          return;
        }
  
        if (!this.selectedResolution) {
          toast.error("Please select a resolution!");
          return;
        }
  
        if (!this.selectedFile) {
          toast.error("Please select a file!");
          return;
        }

        this.isLoading = true;

        await this[MARKETTINGTOOLS__ACTIONS.CREATEBANNER](this.selectedFile);
        this.dialog = false;
        this.selectedCategoryId = null;
        this.selectedResolution = null;
        this.selectedFile = "";
        this.$nextTick(() => {
          this.$refs.fileInput.reset();
        });
      } catch(error) {
        console.log("error while uploading banner")
      } finally {
        this.isLoading = false;
      }

    },

    deletebanner(id) {
      const parameter = {
        id: id,
      };

      this[MARKETTINGTOOLS__ACTIONS.DELETEBANNER](parameter);
      this.deleteDialog = false;
    },

    async uploadFileUpload(file, id) {
      const formData = new FormData();
      formData.append("updated_banner_file", file);
      formData.append("id", id);
      await this[MARKETTINGTOOLS__ACTIONS.UPDATEBANNER](formData);
    },
  },
  mounted() {
    this[MARKETTINGTOOLS__ACTIONS.BANNERS]();
    this.bannerType = this.$route.query["banner-type"];
  },
};
</script>
